<template>
  <div class="d-flex flex-row">
    <button
      type="button"
      class="btn btn-primary position-relative text-nowrap"
      style="min-width:180px"
    >
      <input
        :id="`file-${index}`"
        type="file"
        class="custom-file-input"
        multiple
        @click="uploadFile($event)"
        @change="uploadFile($event)"
      >
      <div class="d-flex flex-row text-nowrap">
        <span
          class="me-1"
          style="max-width: 120px; min-width: 120px"
        > {{ title }} </span>
        <font-awesome-icon
          v-if="currentFiles.length > 0"
          :icon="['fas', 'check']"
          class="text-white"
        />
        <v-icon
          v-else
          icon="upload-white"
        />
      </div>
    </button>
    <font-awesome-icon
      :icon="['fas', 'trash']"
      class=" my-auto ms-3"
      :class="currentFiles.length > 0 ? 'visible' : 'invisible'"
      @click="deleteFiles"
    />
  </div>
</template>
<script>
import Icon from '@/components/common/helpers/Icon.vue';

export default {
  name: 'LoaderUpload',
  components: {
    'v-icon': Icon,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentFiles: [],
    };
  },
  computed: {
    title() {
      if (this.currentFiles.length) {
        if (this.currentFiles.length === 1) {
          const { name } = this.currentFiles[0];
          if (name.length > 12) {
            return `${name.slice(0, 12)}...`;
          }
          return name;
        }
        return `${this.currentFiles.length} fichiers`;
      }
      return 'Choisir un fichier';
    },
  },
  methods: {
    deleteFiles() {
      if (this.currentFiles.length > 0) {
        this.currentFiles = [];
        document.getElementById(`file-${this.index}`).value = '';
        this.$store.dispatch('claim/deleteAttachments', this.index);
        this.$emit('upload', false);
      }
    },
    async uploadFile(event) {
      if (event.target.files.length > 0) {
        this.currentFiles = event.target.files;
        try {
          await this.$store.dispatch('claim/setAttachments', {
            attachments: this.currentFiles,
            index: this.index,
          });
          this.$emit('upload', true);
        } catch {
          this.currentFiles = [];
          this.$store.dispatch('claim/deleteAttachments', this.index);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-file-input{
    width: 100% !important;
    height: 100%;
    position: absolute;
    opacity: 0;
    left: 0;
    top: 0;
}
</style>
